import React from 'react';
import { fabric } from 'fabric';
import ToolBar from '../../../Toolbar/Toolbar';
import events from '../../../../services/events';
import { connect } from 'react-redux';
import { setShowPixelationWindowDialogue } from '../../../../redux/actions/pixelationHandler';
import * as fabricCanvasActions from '../../../../redux/fabricCanvasActions';
import * as sideBarActions from '../../../../redux/sideBarActions';
import * as wallHandler from '../../../../redux/actions/wallHandler';
import * as multiWallHandler from '../../../../redux/actions/multiWallHandler';
import * as homeActions from '../../../../redux/homeActions';
import * as canvasZoomActions from '../../../../redux/canvasZoomActions';
import * as vanillaDesignActions from '../../../../redux/vanillaDesignActions';
import { bindActionCreators } from 'redux';
import * as Constants from '../../../../utilities/constants/Constants';
import './FabricCanvas.scss';
import { Icons } from '../../../../utilities';
import ZoomWarningWindow from '../../../../components/PixelationWarning/ZoomWarningWindow';
import WarningView from '../../../../components/PixelationWarning/WarningView';
import OrderSampleWindow from '../../../../components/PixelationWarning/OrderSampleWindow';
import ContextualMenu from '../../../Toolbar/ContextMenu/ContextualMenu';
import PremiumContentPriceTag from '../../../../components/VanillaDesign/PremiumContentPriceTag/PremiumContentPriceTag';
import {
  getPremiumContentList,
  isSignageSuiteProduct,
  isRoomMode,
  convertImperialToGivenUnitSystem
} from '../../../../utilities/HelperFunctions/HelperFunctions';
import { string } from '../../../../localization';
import DelayLoadingTemplate from '../../../../components/LoadingTemplate/DelayLoadingTemplate';
import DropBoxErrorDialogue from '../../../../components/UploadDialogue/DropBoxErrorDialogue';
import FeedbackDialogue from '../../../../components/FeedbackDialogue/FeedbackDialogue';
import * as CookieUtils from '../../../../utilities/CookieUtils/CookieUtils';
import NavigationButton from '../../../../UI/NavigationButton/NavigationButton';
import WallVisualize from '../../../../UI/WallVisualize/WallVisualize';
import { getPlacings } from '../../../../redux/ProjectData/Project';
import _ from 'lodash';
import { Rnd } from 'react-rnd';
import * as sizeHandler from '../../../../redux/actions/sizeHandler';

const IDLE_TIMEOUT = 60;
let IDLE_SECONDS_COUNTER = 0;

class FabricCanvas extends React.Component {
  state = {
    isDrawing: false,
    showCanvasXLabel: false,
    showCanvasYLabel: false,
    canvasWidth: '',
    canvasHeight: ''
  };

  componentDidMount() {
    const {
      feedbackDuration,
      feedbackState,
      isFeedbackVisible,
      wallCanvas,
      dispatchers
    } = this.props;
    this.checkForIdleStateAndShowDialog();
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );
    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      this.startTimer();
    }

    // Initiate Fabric Canvas
    const mainCanvas = new fabric.Canvas('main-canvas', {
      preserveObjectStacking: true,
      backgroundColor: '#ffffff',
      includeDefaultValues: true
    });
    const roomCanvas = new fabric.Canvas('room-canvas', {
      preserveObjectStacking: true,
      backgroundColor: '#f1f1f1',
      includeDefaultValues: true
    });

    // some properties of canvas like scaleX, scaleY will have high precision digits. canvas.toJSON will hold values upto below mentioned digits.
    // By default it will hold 2 digits. It will be rounded off.
    fabric.Object.NUM_FRACTION_DIGITS = 16;

    const isProjectInitiation = !wallCanvas;

    dispatchers.fabricCanvasActions.setRoomCanvas(roomCanvas);
    dispatchers.fabricCanvasActions.setWallCanvas(mainCanvas);
    dispatchers.fabricCanvasActions.initializeProjectPlacing();

    roomCanvas.wrapperEl.addEventListener(
      'dragenter',
      events.onDragEnter,
      false
    );
    roomCanvas.wrapperEl.addEventListener('dragover', events.onDragOver, false);
    roomCanvas.wrapperEl.addEventListener(
      'dragleave',
      events.onDragLeave,
      false
    );
    roomCanvas.wrapperEl.addEventListener('drop', events.onDrop, false);

    mainCanvas.wrapperEl.addEventListener(
      'dragenter',
      events.onDragEnter,
      false
    );
    mainCanvas.wrapperEl.addEventListener('dragover', events.onDragOver, false);
    mainCanvas.wrapperEl.addEventListener(
      'dragleave',
      events.onDragLeave,
      false
    );
    mainCanvas.wrapperEl.addEventListener('drop', events.onDrop, false);

    if (this.isProjectInitiationFlow()) {
      this.setUpProjectInitiation();
    } else if (!wallCanvas) {
      dispatchers.fabricCanvasActions.setLoadingState(string.LOADING_KEY);
    }
    this.windowDidResize();

    fabric.Object.prototype
      .setControlsVisibility({
        tl: true, // top-left
        mt: false, // middle-top
        tr: true, // top-right
        ml: false, // middle-left
        mr: false, // middle-right
        bl: true, // bottom-left
        mb: false, // middle-bottom
        br: true // bottom-right
      })
      .set({
        transparentCorners: false,
        cornerSize: 12,
        cornerStyle: 'circle',
        cornerColor: 'rgb(128,128,128)',
        borderColor: 'rgb(128,128,128)',
        selectionBackgroundColor: 'rgba(178, 178, 178,0.3)'
        // padding: 5
      });

    mainCanvas.on({
      'mouse:down': this.handleMouseDown,
      'object:moving': this.handleObjectMovement,
      'object:scaling': this.handleObjectResizing,
      'object:rotating': this.handleObjectRotating,
      'object:added': dispatchers.fabricCanvasActions.removeLoadingRect,
      'mouse:up': this.handleMouseUp,
      'selection:created': this.handleObjectCreation,
      'selection:cleared': this.handleObjectClear,
      'selection:updated': this.handleObjectupdation
    });

    roomCanvas.on({
      'mouse:down': this.handleMouseDown,
      'object:moving': this.handleObjectMovement,
      'object:scaling': this.handleObjectResizing,
      'object:rotating': this.handleObjectRotating,
      'object:added': dispatchers.fabricCanvasActions.removeLoadingRect,
      'mouse:up': this.handleMouseUp,
      'selection:created': this.handleObjectCreation,
      'selection:cleared': this.handleObjectClear,
      'selection:updated': this.handleObjectupdation
    });

    fabric.util.addListener(
      document.body,
      'keydown',
      this.handleKeyBoardFunctions
    );

    fabric.util.addListener(document.body, 'mousedown', this.handleAppClick);
    fabric.util.addListener(document.body, 'dblclick', this.handleDoubleClick);

    const orderSampleSelectionContext = this.orderSampleSelectionContext();
    if (orderSampleSelectionContext) {
      orderSampleSelectionContext.strokeStyle = '#BADA55';
      orderSampleSelectionContext.lineJoin = 'round';
      orderSampleSelectionContext.lineCap = 'round';
      orderSampleSelectionContext.lineWidth = 2;
    }

    fabric.Canvas.prototype.setCursor = () => {
      mainCanvas.upperCanvasEl.style.cursor = 'default';
    };

    // resize canvas based on the screen change
    window.addEventListener('resize', this.windowDidResize.bind(this));
    if (!isProjectInitiation) {
      dispatchers.fabricCanvasActions.setLoadingState('');
      dispatchers.fabricCanvasActions.loadCanvasFromProject();
    }
  }

  componentDidUpdate(prevProps) {
    const { activeObject, dispatchers } = this.props;
    if (prevProps.activeObject !== activeObject) {
      if (activeObject) {
        if (
          Object.prototype.hasOwnProperty.call(
            activeObject,
            'hasPixelationWarning'
          ) &&
          activeObject.hasPixelationWarning
        ) {
          dispatchers.fabricCanvasActions.setShowPixelationWarningField(true);
        } else {
          dispatchers.fabricCanvasActions.setShowPixelationWarningField(false);
        }
      } else {
        dispatchers.fabricCanvasActions.setShowPixelationWarningField(false);
      }
    }
  }

  componentWillUnmount() {
    const { feedbackDuration, feedbackState, isFeedbackVisible } = this.props;
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );

    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      this.stopTimer();
    }
    fabric.util.removeListener(document.body, 'mousedown', this.handleAppClick);
  }

  tick = () => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setFeedbackDialogue(true);
  };

  startTimer = () => {
    const { timeStampForDesigner } = this.props;
    this.interval = setInterval(
      this.tick,
      timeStampForDesigner * Constants.SECONDS_TIMER
    );
  };

  stopTimer = () => {
    clearInterval(this.interval);
  };

  checkForIdleStateAndShowDialog = () => {
    this.attachEvent(document, 'click', this.resetTime);
    this.attachEvent(document, 'mousemove', this.resetTime);
    this.attachEvent(document, 'keypress', this.resetTime);
    this.attachEvent(window, 'load', this.resetTime);
    window.setInterval(this.checkIdleTime, 1000);
  };

  attachEvent = (element, eventName, eventHandler) => {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
      return true;
    }
    if (element.attachEvent) {
      element.attachEvent(`on${eventName}`, eventHandler);
      return true;
    }
    // nothing to do, browser too old or non standard anyway
    return false;
  };

  checkIdleTime = () => {
    IDLE_SECONDS_COUNTER++;
    //  var oPanel = document.getElementById("SecondsUntilExpire");
    //  if (oPanel)
    //      oPanel.innerHTML = (IDLE_TIMEOUT - _idleSecondsCounter) + "";
    if (IDLE_SECONDS_COUNTER >= IDLE_TIMEOUT) {
      window.clearInterval(IDLE_SECONDS_COUNTER);
      // alert('Time expired!');
      // document.location.href = "logout.html";
    }
  };

  resetTime = () => {
    IDLE_SECONDS_COUNTER = 0;
  };

  orderSampleSelectionContext = () => {
    const canvas = document.querySelector('#draw');
    if (canvas) {
      return canvas.getContext('2d');
    }
    return null;
  };

  calculateRectSize = () => {
    const { projectHeight, wallCanvas, dispatchers } = this.props;
    const scale = projectHeight / wallCanvas.height;
    const sampleSize = dispatchers.fabricCanvasActions.sampleModelSize();
    return {
      width: sampleSize.width / scale,
      height: sampleSize.height / scale
    };
  };

  draw = e => {
    const { dispatchers, defaultMaskStepForOrderSample } = this.props;
    if (defaultMaskStepForOrderSample === Constants.LOAD_DEFAULT) {
      // mask is incremented......enabling to draw
      dispatchers.fabricCanvasActions.setDefaultMaskStepForOrderSample(
        defaultMaskStepForOrderSample + 1
      );
    }

    const rectSize = this.calculateRectSize();
    const canvas = document.getElementById('main-canvas');
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    let sampleWidthX;
    let sampleHeightY;
    const axisX = e.nativeEvent.offsetX;
    const axisY = e.nativeEvent.offsetY;

    // left
    if (axisX - rectSize.width / 2 < 0) {
      sampleWidthX = 0;
    } else if (axisX + rectSize.width / 2 > canvasWidth) {
      // right
      sampleWidthX = canvasWidth - rectSize.width;
    } else {
      // normal
      sampleWidthX = axisX - rectSize.width / 2;
    }

    // top
    if (axisY - rectSize.height / 2 < 0) {
      sampleHeightY = 0;
    } else if (axisY + rectSize.height / 2 > canvasHeight) {
      // bottom
      sampleHeightY = canvasHeight - rectSize.height;
    } else {
      // normal

      sampleHeightY = axisY - rectSize.height / 2;
    }

    const context = this.orderSampleSelectionContext();
    context.save();
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = 'black';
    context.globalAlpha = 0.5;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.restore();
    context.save();
    context.globalCompositeOperation = 'destination-out';
    context.beginPath();

    context.fillRect(
      sampleWidthX,
      sampleHeightY,

      rectSize.width,
      rectSize.height
    );

    context.restore();

    if (e.type == 'mouseup') {
      dispatchers.fabricCanvasActions.setOrderSampleDetails({
        lastX: sampleWidthX === 0 ? 0.1 : sampleWidthX,
        lastY: sampleHeightY === 0 ? 0.1 : sampleHeightY
      });
    }
  };

  handleObjectMovement = e => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.objectDragged(e);
  };

  handleObjectResizing = e => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.objectResized(e);
  };

  handleObjectRotating = e => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.objectRotated(e);
  };

  handleMouseDown = e => {
    const { dispatchers, zoomInState, zoomOutState } = this.props;
    if (zoomInState) {
      dispatchers.canvasZoomActions.handleZoomInForCanvas(e);
    } else if (zoomOutState) {
      dispatchers.canvasZoomActions.handleZoomOutForCanvas(e);
    } else {
      dispatchers.fabricCanvasActions.activeObjectHandler(e.target);
      dispatchers.fabricCanvasActions.mouseDown(e);
    }
  };

  handleMouseUp = e => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.mouseUp(e);
  };

  handleKeyBoardFunctions = e => {
    const { wallCanvas, roomCanvas, dispatchers } = this.props;
    if (e !== undefined) {
      if (
        e.target.type !== 'text' &&
        e.target.type !== 'number' &&
        e.target.type !== 'textarea' &&
        e.target.type !== 'password'
      ) {
        const wallActiveObject = wallCanvas.getActiveObject();
        const roomActiveObject = roomCanvas.getActiveObject();
        let activeCanvas = wallCanvas;
        let activeObject = wallActiveObject;
        if (roomActiveObject && dispatchers.isRoomMode()) {
          activeCanvas = roomCanvas;
          activeObject = roomActiveObject;
        }
        if (activeObject) {
          const key = e.which || e.keyCode;

          if (
            Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
            activeObject.placing.placeableType != Constants.SCENE_KEY &&
            key != Constants.BACKSPACE_KEY_CODE &&
            key != Constants.DELETE_KEY_CODE
          ) {
            if (key === Constants.LEFT_ARROW_KEY_CODE) {
              activeObject.set({ left: activeObject.left - 10 });
            } else if (key === Constants.UP_ARROW_KEY_CODE) {
              activeObject.set({ top: activeObject.top - 10 });
            } else if (key === Constants.RIGHT_ARROW_KEY_CODE) {
              activeObject.set({ left: activeObject.left + 10 });
            } else if (key === Constants.DOWN_ARROW_KEY_CODE) {
              activeObject.set({ top: activeObject.top + 10 });
            }
          }

          if (
            key === Constants.BACKSPACE_KEY_CODE ||
            key === Constants.DELETE_KEY_CODE
          ) {
            dispatchers.fabricCanvasActions.handleDeleteKey(activeObject);
          }
          activeCanvas.renderAll();
        }
      }
    }
  };

  handleObjectClear = e => {
    const { dispatchers } = this.props;
    if (!(e.e !== undefined && e.e.metaKey)) {
      dispatchers.fabricCanvasActions.clearActiveObjects();
    }
  };

  handleObjectCreation = e => {
    const { dispatchers, selectedObjects, isStickerType } = this.props;
    if (e.target) {
      dispatchers.fabricCanvasActions.setControlEdges(e.target);
      if (
        ((e.e != undefined && (e.e.shiftKey || e.e.metaKey)) ||
          isStickerType) &&
        selectedObjects.length > 0
      ) {
        // shift key/ cmd key is enabled
        dispatchers.fabricCanvasActions.setActiveObjectGroup(e);
      } else {
        dispatchers.fabricCanvasActions.setActiveObjectSingle(e);
      }
    }
  };

  handleObjectupdation = e => {
    const { dispatchers, isStickerType } = this.props;
    if (e.target) {
      if (
        (e.e != undefined && (e.e.shiftKey || e.e.metaKey)) ||
        isStickerType
      ) {
        // shift key/ cmd key is enabled
        dispatchers.fabricCanvasActions.setActiveObjectGroup(e);
      } else {
        dispatchers.fabricCanvasActions.setActiveObjectSingle(e);
      }
    }
  };

  handleCanvasMouseDown = () => {
    this.setState({
      isDrawing: true
    });
  };

  handleCanvasMouseUp = e => {
    this.setState({
      isDrawing: false
    });

    this.draw(e);
  };

  handleCanvasOnMove = e => {
    const { isDrawing } = this.state;
    if (isDrawing) {
      this.draw(e);
    }
  };

  renderSelectionCanvas = () => {
    const {
      wallCanvas,
      defaultMaskStepForOrderSample,
      dispatchers
    } = this.props;
    const width = wallCanvas ? wallCanvas.width : 800;
    const height = wallCanvas ? wallCanvas.height : 800;
    if (defaultMaskStepForOrderSample === Constants.INITIAL_LOAD) {
      // 'mask set to 1, reload the canvas forcefully to obtain canvas'
      dispatchers.fabricCanvasActions.setDefaultMaskStepForOrderSample(
        defaultMaskStepForOrderSample + 1
      );
    }

    return (
      <canvas
        id='draw'
        style={{
          top: wallCanvas ? wallCanvas._offset.top : '0px',
          left: wallCanvas ? wallCanvas._offset.left : '0px'
        }}
        width={width}
        height={height}
        onMouseMove={e => this.handleCanvasOnMove(e)}
        onMouseDown={e => {
          this.handleCanvasMouseDown(e);
        }}
        onMouseUp={e => {
          this.handleCanvasMouseUp(e);
        }}
      />
    );
  };

  renderDefaultSelectionCanvas = () => {
    const context = this.orderSampleSelectionContext();
    if (context) {
      const rectSize = this.calculateRectSize();
      const { wallCanvas, dispatchers } = this.props;
      if (wallCanvas) {
        context.save();
        context.clearRect(0, 0, wallCanvas.width, wallCanvas.height);
        context.fillStyle = 'black';
        context.globalAlpha = 0.5;
        context.fillRect(0, 0, wallCanvas.width, wallCanvas.height);
        context.restore();
        context.save();
        context.globalCompositeOperation = 'destination-out';
        context.beginPath();
        context.fillRect(
          wallCanvas.width / 2 - rectSize.width / 2,
          wallCanvas.height / 2 - rectSize.height / 2,
          rectSize.width,
          rectSize.height
        );
        context.restore();

        dispatchers.fabricCanvasActions.setOrderSampleDetails({
          lastX: wallCanvas.width / 2 - rectSize.width / 2,
          lastY: wallCanvas.height / 2 - rectSize.height / 2
        });
      }
    }
  };

  isProjectInitiationFlow = () => {
    const { progressData, projectIsInitiated, wallCanvas } = this.props;
    return progressData === 100 && !projectIsInitiated && wallCanvas;
  };

  setUpProjectInitiation = () => {
    const {
      dispatchers,
      wallCanvas,
      projectId,
      projectWidth,
      projectHeight
    } = this.props;
    dispatchers.fabricCanvasActions.fetchingIsDone();
    dispatchers.fabricCanvasActions.setLoadingState(null);
    if (projectId) {
      dispatchers.fabricCanvasActions.loadCanvas();
    } else {
      dispatchers.fabricCanvasActions.initiateProject();
    }
    wallCanvas.selection = false;
    wallCanvas.setDimensions(
      { width: projectWidth, height: projectHeight },
      { cssOnly: true }
    );
    this.windowDidResize();
  };

  handleDoubleClick = e => {
    const { dispatchers } = this.props;
    const draggableCanvas = document.getElementById('rnd');
    if (e.target == draggableCanvas) {
      dispatchers.fabricCanvasActions.setViewMode(Constants.TWO_D_TYPE);
    }
  };

  handleAppClick = e => {
    const { zoomInState, zoomOutState, dispatchers } = this.props;
    if (
      (zoomInState || zoomOutState) &&
      e.target.id !== 'toolbar-zoom-out' &&
      e.target.id !== 'toolbar-zoom-in' &&
      e.target.id !== 'toolbar-item-zoom-out' &&
      e.target.id !== 'toolbar-item-zoom-in'
    ) {
      dispatchers.canvasZoomActions.resetZoomState();
    }

    const playground = document.getElementById('outerCanvas');
    const draggableCanvas = document.getElementById('rnd');
    if (e.target == draggableCanvas) {
      dispatchers.fabricCanvasActions.selectObject(e.target);
    }
    if (e.target === playground) {
      dispatchers.fabricCanvasActions.selectObject(null);
    }
  };

  getTemplate2DUrl = () => {
    const { selectedProduct } = this.props;
    if (selectedProduct.activeProductSize) {
      return selectedProduct.activeProductSize.activeTemplate.imageUrl;
    }
    return '';
  };

  canShowRuler = () => {
    const { hideRuler, isStickerType, viewType } = this.props;
    return (
      !hideRuler || (isStickerType && viewType == Constants.EDIT_WORKSPACE_TYPE)
    );
  };

  showOrHideRuler = () => {
    const { unitSystem, dispatchers } = this.props;
    if (this.canShowRuler()) {
      let scaleUnit = '';
      if (unitSystem === Constants.METRIC_KEY) {
        scaleUnit = string.PLACEHOLDER_CM_STRING_KEY;
      } else {
        scaleUnit = string.PLACEHOLDER_INCHES_STRING_KEY;
      }
      return (
        <>
          <div className='ruler-label-container'>
            <div className='ruler-label-normal'>{scaleUnit}</div>
          </div>
          {dispatchers.canvasZoomActions.renderRulerCanvasHorizontal()}
          {dispatchers.canvasZoomActions.renderRulerCanvasVertical()}
          {dispatchers.canvasZoomActions.renderRuler()}
        </>
      );
    }
    return null;
  };

  canShow2DTemplate = () => {
    const { selectedProduct, viewType } = this.props;
    return (
      isSignageSuiteProduct() &&
      selectedProduct &&
      selectedProduct.constraintType == Constants.CONSTRAINT_TYPE_PDF &&
      viewType == Constants.TWO_D_TYPE
    );
  };

  renderCanvasLines = () => {
    const { project, wallCanvas } = this.props;
    const { canvasRowsCount, canvasColumnsCount } = project;

    const columnLines = [];
    if (canvasColumnsCount > 1) {
      _.times(canvasColumnsCount, index => {
        if (index != 0) {
          const leftPosition = wallCanvas
            ? `${(wallCanvas.width / canvasColumnsCount) * index}px`
            : '0px';
          columnLines.push(
            <div
              style={{
                borderLeft: '3px solid #f4f4f4',
                width: '0px',
                left: leftPosition,
                position: 'absolute',
                top: '0px',
                height: wallCanvas ? wallCanvas.height : '100px'
              }}
            />
          );
        }
      });
    }
    if (canvasRowsCount > 1) {
      _.times(canvasRowsCount, index => {
        if (index != 0) {
          const topPosition = wallCanvas
            ? (wallCanvas.height / canvasRowsCount) * index
            : '0px';
          columnLines.push(
            <div
              style={{
                borderTop: '3px solid #f4f4f4',
                width: wallCanvas ? wallCanvas.width : '100px',
                position: 'absolute',
                top: topPosition,
                height: '0px'
              }}
            />
          );
        }
      });
    }
    return <>{columnLines}</>;
  };

  renderCanvasLabels = () => {
    const {
      showCanvasXLabel,
      showCanvasYLabel,
      canvasWidth,
      canvasHeight
    } = this.state;
    const { unitSystem, wallCanvas } = this.props;
    const labelStyle = {
      width: '100px',
      display: 'inline-block',
      height: '30px',
      background: '#3c3c3c',
      color: 'white',
      lineHeight: '30px'
    };
    return (
      <>
        {showCanvasXLabel ? (
          <div
            style={{
              width: wallCanvas ? wallCanvas.width : '100px',
              position: 'absolute',
              margin: 'auto',
              borderRadius: '5px !important',
              textAlign: 'center'
            }}
          >
            <span style={labelStyle}>
              {canvasWidth}
              {unitSystem === Constants.IMPERIAL_KEY
                ? string.INCHES_UNIT_STRING_KEY
                : string.CM_KEY}
            </span>
          </div>
        ) : null}
        {showCanvasYLabel ? (
          <div
            style={{
              width: wallCanvas ? wallCanvas.height : '100px',
              position: 'absolute',
              left: '-30px',
              textAlign: 'center',
              borderRadius: '5px',
              transform: 'rotate(-90deg)',
              transformOrigin: 'top left'
            }}
          >
            <span style={labelStyle}>
              {canvasHeight}
              {unitSystem === Constants.IMPERIAL_KEY
                ? string.INCHES_UNIT_STRING_KEY
                : string.CM_KEY}
            </span>
          </div>
        ) : null}
      </>
    );
  };

  draggableCanvasResized = (ref, position) => {
    const { unitSystem, dispatchers, projectHeight, wallCanvas } = this.props;
    const scale = projectHeight / wallCanvas.height;
    const newCanvasWidth = (ref.offsetWidth * scale).toFixed(2);
    const newCanvasHeight = (ref.offsetHeight * scale).toFixed(2);

    const canvasWidthInCurrentUnit = convertImperialToGivenUnitSystem(
      newCanvasWidth,
      unitSystem
    );
    const canvasHeightInCurrentUnit = convertImperialToGivenUnitSystem(
      newCanvasHeight,
      unitSystem
    );
    dispatchers.sizeHandler.customWidthChange(canvasWidthInCurrentUnit);
    dispatchers.sizeHandler.customHeightChange(canvasHeightInCurrentUnit);

    dispatchers.fabricCanvasActions.setDraggableCanvasPosition(
      position.x,
      position.y
    );

    this.setState({
      showCanvasXLabel: false,
      showCanvasYLabel: false
    });

    if (ref.offsetWidth > 100) {
      this.setState({
        showCanvasXLabel: true,
        canvasWidth: canvasWidthInCurrentUnit
      });
    }
    if (ref.offsetHeight > 100) {
      this.setState({
        showCanvasYLabel: true,
        canvasHeight: canvasHeightInCurrentUnit
      });
    }
  };

  renderCanvas = () => {
    const {
      selectedProduct,
      showPixelationWarningField,
      viewType,
      wallCanvas,
      dispatchers,
      zoomInState,
      zoomOutState,
      draggableCanvasPosition,
      selectedDefaultSize
    } = this.props;

    // Signage Suite display settings
    let template2DUrl = '';
    if (isSignageSuiteProduct()) {
      if (selectedProduct) {
        template2DUrl = this.getTemplate2DUrl();
      }
    }

    let canvasClass = 'ruler-canvas';
    if (zoomInState) {
      canvasClass = 'ruler-canvas zoom-in-cursor';
    } else if (zoomOutState) {
      canvasClass = 'ruler-canvas zoom-out-cursor';
    }

    return (
      <div
        style={{
          position: 'relative',
          height: wallCanvas ? wallCanvas.height : '100px',
          width: wallCanvas ? wallCanvas.width : '100px'
        }}
      >
        {this.showOrHideRuler()}
        {showPixelationWarningField && viewType === Constants.TWO_D_TYPE ? (
          <input
            type='image'
            alt='warning'
            style={{
              position: 'fixed',
              outline: 'none',
              top: wallCanvas ? wallCanvas._offset.top + 5 : '9px',
              zIndex: '15',
              left: wallCanvas
                ? wallCanvas._offset.left + wallCanvas.width - 40
                : '800px',
              borderRadius: '50%',
              backgroundColor: '#fecc2f'
            }}
            className='pixelation-warning-icon'
            src={Icons.icon_warning}
            onClick={() => {
              dispatchers.setShowPixelationWindowDialogue(true);
            }}
          />
        ) : null}
        <div
          className={this.canShowRuler() ? 'wrapper-canvas' : 'normal-canvas'}
          style={{ position: 'relative' }}
        >
          <div className={canvasClass}>
            <Rnd
              id='rnd'
              position={{
                x:
                  viewType == Constants.TWO_D_TYPE
                    ? 0
                    : draggableCanvasPosition.x,
                y:
                  viewType == Constants.TWO_D_TYPE
                    ? 0
                    : draggableCanvasPosition.y
              }}
              onDragStop={(e, d) => {
                dispatchers.fabricCanvasActions.setDraggableCanvasPosition(
                  d.x,
                  d.y
                );
              }}
              enableResizing={
                viewType == Constants.THREE_D_TYPE &&
                selectedDefaultSize == 'custom'
              }
              onResize={(e, direction, ref, delta, position) => {
                this.draggableCanvasResized(ref, position);
              }}
              onResizeStop={() => {
                this.setState({ showCanvasXLabel: false });
                this.setState({ showCanvasYLabel: false });
              }}
              bounds='.room-mid-wall'
            >
              <div
                style={{
                  pointerEvents:
                    viewType == Constants.THREE_D_TYPE ? 'none' : null
                }}
              >
                <canvas id='main-canvas' />
              </div>
              {dispatchers.homeActions.checkIfMultiCanvas()
                ? this.renderCanvasLines()
                : null}
              {this.renderCanvasLabels()}

              {/* {dispatchers.homeActions.checkIfCanvasApp() &&
                viewType == Constants.THREE_D_TYPE ? (
                  <>
                    <div
                      style={{
                        width: '30px',
                        height: wallCanvas ? wallCanvas.height + 30 : '100px',
                        background: '#b7b7b7',
                        transform: 'skewY(45deg)',
                        transformOrigin: 'top left',
                        position: 'absolute',
                        top: '0px',
                        left: wallCanvas ? wallCanvas.width + 30 : '100px'
                      }}
                    />
                    <div
                      style={{
                        width: wallCanvas ? wallCanvas.width + 30 : '100px',
                        height: '30px',
                        background: '#b7b7b7',
                        transform: 'skewX(45deg)',
                        // top: '30px',
                        top: wallCanvas ? wallCanvas.height + 30 : '100px',
                        left: '0px',
                        position: 'absolute',
                        transformOrigin: 'top left'
                      }}
                    />
                  </>
                ) : null} */}
            </Rnd>

            {this.canShow2DTemplate() ? (
              <img
                id='template-2d'
                src={template2DUrl}
                alt=''
                style={{
                  width: wallCanvas ? wallCanvas.width : '100px',
                  height: wallCanvas ? wallCanvas.height : '100px'
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  getWallColor = () => {
    const { defaultWallColor, multiWallProjects } = this.props;
    let wallColorString = '#';
    if (multiWallProjects.length >= 2) {
      wallColorString += 'aaa';
    } else if (defaultWallColor) {
      wallColorString += defaultWallColor;
    }
    return wallColorString;
  };

  renderWall = () => {
    const {
      wallCanvas,
      dispatchers,
      leftWallPreviews,
      rightWallPreviews,
      dimensions,
      viewType
    } = this.props;

    const { canvasWallScaleWidth, canvasWallScaleHeight } = dimensions;
    const leftWallSize = dispatchers.multiWallHandler.leftWallSize();
    const rightWallSize = dispatchers.multiWallHandler.rightWallSize();

    const element = document.getElementById('room-wall-design');

    const wallSidesWidth =
      this.refCallback && wallCanvas
        ? (this.refCallback.offsetWidth - canvasWallScaleWidth) / 2
        : 0;

    const ceilingOrFloorHeight =
      this.refCallback && wallCanvas
        ? (this.refCallback.offsetHeight - canvasWallScaleHeight) / 2
        : 0;

    if (element && wallCanvas) {
      element.style.setProperty('--wall-color', this.getWallColor());
      element.style.setProperty('--wall-side-width', `${wallSidesWidth}px`);
      element.style.setProperty(
        '--ceiling-or-floor-heigt',
        `${ceilingOrFloorHeight}px`
      );
      element.style.setProperty(
        '--canvas-wall-width',
        `${canvasWallScaleWidth}px`
      );
      element.style.setProperty(
        '--canvas-wall-height',
        `${canvasWallScaleHeight}px`
      );

      element.style.setProperty(
        '--wall-side-overlay-width',
        `${wallSidesWidth - 10}px`
      );
    }

    const wallVisualizeIds = dispatchers.multiWallHandler.generateWallVisualizeIds();
    const direction = dispatchers.multiWallHandler.getActiveWallVisualizeDirection(
      wallVisualizeIds
    );

    return (
      <div
        id='room-wall-design'
        className={
          dispatchers.multiWallHandler.hasSingleWallDesign()
            ? 'single-wall-design'
            : 'multi-wall-design'
        }
      >
        <div
          className={
            dispatchers.multiWallHandler.hasSingleWallDesign()
              ? 'room-ceiling'
              : 'room-ceiling multiwall-ceiling'
          }
        />
        {viewType != Constants.TWO_D_TYPE && (
          <img
            id='ceiling-shadow'
            src={Icons.roomWallCeilingShadow}
            alt='ceiling'
          />
        )}
        {dispatchers.multiWallHandler.hasSingleWallDesign() ? null : (
          <div id='visualize-container'>
            <WallVisualize
              selectedDirection={direction}
              setSelectedDirection={newDirection => {
                const newIndex = dispatchers.multiWallHandler.getWallIndex(
                  direction,
                  newDirection
                );
                dispatchers.multiWallHandler.navigateToProjectWithIndex(
                  newIndex
                );
              }}
              wallVisualizeIds={wallVisualizeIds}
              isActive
            />
          </div>
        )}
        {dispatchers.multiWallHandler.hasSingleWallDesign() ? (
          <div className='room-left-wall'>
            {viewType != Constants.TWO_D_TYPE && (
              <img
                className='wall-side-shadow'
                src={Icons.roomWallWallLeftShadow}
                alt='wallLeft'
              />
            )}
          </div>
        ) : (
          <div className='room-left-wall left-multi-wall'>
            {leftWallPreviews.length ? (
              <>
                <img
                  style={{
                    width: `${leftWallSize.width}px`,
                    height: `${leftWallSize.height}px`
                  }}
                  src={leftWallPreviews[0].image_data}
                  alt='preview'
                />
                <div className='wall-side-overlay' />
              </>
            ) : null}
          </div>
        )}

        <div className='room-mid-wall'>
          {dispatchers.homeActions.checkIfCanvasApp() && (
            <div style={{ position: 'absolute' }}>
              <canvas id='room-canvas' />
            </div>
          )}
          <div style={{ position: 'absolute' }}>{this.renderCanvas()}</div>
        </div>
        {dispatchers.multiWallHandler.hasSingleWallDesign() ? (
          <div className='room-right-wall'>
            {viewType != Constants.TWO_D_TYPE && (
              <img
                className='wall-side-shadow'
                src={Icons.roomWallWallRightShadow}
                alt='wallRight'
              />
            )}
          </div>
        ) : (
          <div className='room-right-wall right-multi-wall'>
            {rightWallPreviews.length ? (
              <>
                <img
                  style={{
                    height: `${rightWallSize.height}px`
                  }}
                  src={rightWallPreviews[0].image_data}
                  alt='preview'
                />
                <div className='wall-side-overlay' />
              </>
            ) : null}
          </div>
        )}
        {viewType != Constants.TWO_D_TYPE && (
          <img
            className='room-floor'
            src={Icons.roomWallFloor}
            alt='roomWallFloor'
          />
        )}
        {dispatchers.multiWallHandler.hasSingleWallDesign() &&
        viewType != Constants.TWO_D_TYPE ? (
          <>
            <div id='ceiling-left-3D-canvas' />
            <img
              id='ceiling-left-3D-shadow'
              src={Icons.roomWallCeilingLeftShadow}
              alt='ceilingLeftShadow'
            />

            <div id='ceiling-right-3D-canvas' />
            <img
              id='ceiling-right-3D-shadow'
              src={Icons.roomWallCeilingRightShadow}
              alt='ceilingRightShadow'
            />

            <div id='floor-left-3D-canvas' />
            <img
              id='floor-left-3D-shadow'
              src={Icons.roomWallFloorLeftShadow}
              alt='floorLeftShadow'
            />

            <div id='floor-right-3D-canvas' />
            <img
              id='floor-right-3D-shadow'
              src={Icons.roomWallFloorRightShadow}
              alt='floorRightShadow'
            />
          </>
        ) : null}
      </div>
    );
  };

  windowDidResize() {
    const { dispatchers } = this.props;
    if (this.refCallback) {
      dispatchers.fabricCanvasActions
        .windowDidResize(
          this.refCallback.offsetWidth,
          this.refCallback.offsetHeight
        )
        .then(() => {
          const { dimensions } = this.props;
          const { projectScaleWidth, projectScaleHeight } = dimensions;

          if (document.getElementById('outerCanvasHorizontal')) {
            document.getElementById(
              'outerCanvasHorizontal'
            ).width = projectScaleWidth;
            dispatchers.canvasZoomActions.drawOuterCanvasHorizontal();
          }
          if (document.getElementById('outerCanvasVertical')) {
            document.getElementById(
              'outerCanvasVertical'
            ).height = projectScaleHeight;
            dispatchers.canvasZoomActions.drawOuterCanvasVertical();
          }
        });
    }
  }

  render() {
    const {
      viewOnlyPreviewMode,
      dispatchers,
      dropboxUploadDialog,
      showRequestSampleWindow,
      showPixelationWarningField,
      showPixelationWindowDialogue,
      showFeedbackDialogue,
      dropBoxErrorFlag,
      loaderCoordinates,
      uploadDialogue,
      defaultMaskStepForOrderSample,
      isVanilla,
      project,
      wallCanvas
    } = this.props;

    if (this.isProjectInitiationFlow()) {
      this.setUpProjectInitiation();
    }
    let premiumContentList = null;
    if (project && getPlacings(project)) {
      premiumContentList = getPremiumContentList(getPlacings(project));
    }

    const wallSidesWidth =
      this.refCallback && wallCanvas
        ? (this.refCallback.offsetWidth - wallCanvas.width) / 2
        : 0;

    return (
      <div
        className='playground'
        id='root-playground'
        style={{ pointerEvents: viewOnlyPreviewMode ? 'none' : null }}
      >
        {showPixelationWarningField ? (
          <WarningView
            isMultiWall={dispatchers.multiWallHandler.hasMultiWallDesign()}
          />
        ) : null}
        {dispatchers.wallHandler.canShowLeftNavigatonButton() ? (
          <NavigationButton
            direction='left'
            clickHandler={dispatchers.wallHandler.actionNavigateLeft}
            wallSidesWidth={wallSidesWidth}
          />
        ) : null}

        <div
          className='canvas-wrapper d-flex justify-content-center align-items-center position-relative'
          id='outerCanvas'
          ref={input => {
            this.refCallback = input;
          }}
        >
          {dispatchers.multiWallHandler.hasSingleWallDesign() ||
          dispatchers.multiWallHandler.hasMultiWallDesign()
            ? this.renderWall()
            : this.renderCanvas()}
          {showRequestSampleWindow ? <OrderSampleWindow /> : null}
          {showRequestSampleWindow ? this.renderSelectionCanvas() : null}
          {showRequestSampleWindow &&
          defaultMaskStepForOrderSample === Constants.LOAD_DEFAULT // code has to be optimised
            ? this.renderDefaultSelectionCanvas()
            : null}
          {showFeedbackDialogue ? (
            <FeedbackDialogue
              onDisplay={this.stopTimer}
              onFade={this.startTimer}
            />
          ) : null}
          {dropBoxErrorFlag ? <DropBoxErrorDialogue /> : null}
          {loaderCoordinates.left != null ? (
            <DelayLoadingTemplate position={loaderCoordinates} />
          ) : null}
          <div
            className={
              uploadDialogue || dropboxUploadDialog ? 'modal-overlay' : null
            }
          />
          {premiumContentList && premiumContentList.length && isVanilla ? (
            <PremiumContentPriceTag />
          ) : null}
        </div>
        {!viewOnlyPreviewMode ? <ToolBar /> : null}
        {!viewOnlyPreviewMode ? <ContextualMenu /> : null}
        {showPixelationWindowDialogue ? <ZoomWarningWindow /> : null}
        {dispatchers.wallHandler.canShowRightNavigatonButton() ? (
          <NavigationButton
            direction='right'
            clickHandler={dispatchers.wallHandler.actionNavigateRight}
            wallSidesWidth={wallSidesWidth}
          />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    progressData: state.modal.progressData,
    projectIsInitiated: state.modal.projectIsInitiated,
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    dimensions: state.fabricCanvas.dimensions,
    wallCanvas: state.fabricCanvas.wallCanvas,
    roomCanvas: state.fabricCanvas.roomCanvas,
    defaultWallColor: state.modal.storeData.defaultWallColor,
    uploadDialogue: state.sideBar.uploadDialogue,
    showPixelationWarningField: state.fabricCanvas.showPixelationWarningField,
    showPixelationWindowDialogue:
      state.fabricCanvas.showPixelationWindowDialogue,
    projectId: state.finalCheck.project.id,
    project: state.finalCheck.project,
    dropboxUploadDialog: state.sideBar.dropboxUploadDialog,
    showRequestSampleWindow: state.fabricCanvas.showRequestSampleWindow,
    hideRuler: state.modal.storeData.hideRuler,
    activeObject: state.fabricCanvas.activeObject,
    viewOnlyPreviewMode: state.modal.envData.view_only_preview_mode,
    isVanilla: state.modal.envData.is_vanilla_designer,
    helpWindowIsVisible: state.fabricCanvas.helpWindowIsVisible,
    defaultMaskStepForOrderSample:
      state.fabricCanvas.defaultMaskStepForOrderSample,
    loadingCount: state.fabricCanvas.loadingCount,
    language: state.home.language,
    loaderCoordinates: state.sideBar.loaderCoordinates,
    selectedObjects: state.fabricCanvas.selectedObjects,
    dropBoxErrorFlag: state.sideBar.dropBoxErrorFlag,
    unitSystem: state.home.unitSystem,
    redrawCanvas: state.fabricCanvas.redrawCanvas,
    category: state.modal.envData.category,
    toolBarCoordinates: state.fabricCanvas.draggableToolPosition,
    showFeedbackDialogue: state.fabricCanvas.showFeedbackDialogue,
    feedbackState: state.fabricCanvas.feedbackState,
    zoomInState: state.fabricCanvas.zoomInState,
    zoomOutState: state.fabricCanvas.zoomOutState,
    timeStampForDesigner: state.modal.envData.edit_duration,
    feedbackDuration: state.modal.envData.feedback_duration,
    tabName: state.sideBar.tabName,
    isFeedbackVisible: state.modal.storeData.showFeedback,
    selectedProduct: state.home.selectedProduct,
    viewType: state.fabricCanvas.viewType,
    isStickerType: state.modal.envData.is_sticker_type,
    multiWallProjects: state.finalCheck.multiWallProjects,
    leftWallPreviews: state.finalCheck.leftWallPreviews,
    rightWallPreviews: state.finalCheck.rightWallPreviews,
    draggableCanvasPosition: state.fabricCanvas.draggableCanvasPosition,
    selectedDefaultSize: state.home.selectedDefaultSize,
    canvasRowsCount: state.finalCheck.project.canvasRowsCount,
    canvasColumnsCount: state.finalCheck.project.canvasColumnsCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      setShowPixelationWindowDialogue: bindActionCreators(
        setShowPixelationWindowDialogue,
        dispatch
      ),
      isRoomMode: bindActionCreators(isRoomMode, dispatch),
      vanillaDesignActions: bindActionCreators(vanillaDesignActions, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch),
      canvasZoomActions: bindActionCreators(canvasZoomActions, dispatch),
      wallHandler: bindActionCreators(wallHandler, dispatch),
      multiWallHandler: bindActionCreators(multiWallHandler, dispatch),
      sizeHandler: bindActionCreators(sizeHandler, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FabricCanvas);
